// Module
var code = "<div class=\"box-message <%= type %> <%= subclass %>\"> <p><%= message %></p> </div> ";
// Exports
module.exports = code;